var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58663 2.66675H4.0133C3.25115 2.66675 2.6333 3.2846 2.6333 4.04675V19.9534C2.6333 20.7156 3.25115 21.3334 4.0133 21.3334H8.58663C9.34879 21.3334 9.96663 20.7156 9.96663 19.9534V4.04675C9.96663 3.2846 9.34879 2.66675 8.58663 2.66675Z",
    fill: "#00495F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 2.66675H15.3467C14.5845 2.66675 13.9667 3.2846 13.9667 4.04675V19.9534C13.9667 20.7156 14.5845 21.3334 15.3467 21.3334H19.92C20.6822 21.3334 21.3 20.7156 21.3 19.9534V4.04675C21.3 3.2846 20.6822 2.66675 19.92 2.66675Z",
    fill: "#00495F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.8c528457e70fce018c8c5b2b7c7f3352.svg";
export { ForwardRef as ReactComponent };